module.exports = __webpack_public_path__ + "img/lena.c910b690.png";